import React from "react";
import CreateNewRole from "../../components/AdminTabs/AdminChangePassword/CreateNewRole";

const CreateNewRolePage = () => {
  return (
    <div>
      <CreateNewRole />
    </div>
  );
};

export default CreateNewRolePage;
